import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import { DateFormats } from 'common/dates/date.enums';

import { LOCALE, TIMEZONE } from './date.constants';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

function fixFormatForDayjs(format: string) {
  return format.replace(/yyyy/g, DateFormats.Year).replace(/dd/g, DateFormats.Day);
}

export const getDateWithFormat = (date: string | Date, format: DateFormats) => {
  return dayjs(date).locale('en').format(format);
};

export const getDateFromFormat = (date: string | Date, format = DateFormats.StandardDateFormat): Dayjs => {
  const fixedFormat = fixFormatForDayjs(format);
  let parsed = dayjs(date, fixedFormat, true);

  if (!parsed.isValid()) {
    return parsed;
  }

  parsed = parsed.tz(TIMEZONE, true);

  return parsed.startOf('day');
};

export const getCurrentDayjsDate = (): Dayjs => {
  return dayjs().tz(TIMEZONE).locale(LOCALE);
};

export const isValidDateBeforeNow = (date: string, format = DateFormats.StandardDateFormat) => {
  const parsed = getDateFromFormat(date, format);

  return parsed.isValid() && parsed.isBefore(getCurrentDayjsDate());
};
